import React from "react";
import PropTypes from "prop-types";

const Challenge = props => {
  return (
    <div className="challenge">
      <div className="roundCheck">
        <input type="checkbox" id="checkbox" checked={props.checked > 0} readOnly/>
        <label htmlFor="checkbox" />
      </div>
      <div className="contentContainer">
        <p className="challengeContent">{props.name}</p>
        <img className="chellengeIcon" src={props.badge} alt=""/>
      </div>
    </div>
  );
};

Challenge.propTypes  = {
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  badge: PropTypes.string.isRequired
}

export default Challenge;
